import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingNabidkaTisk = lazy(() =>
  import('@/modules/leasing/LeasingNabidkaTisk').then((m) => ({ default: m.LeasingNabidkaTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/nabidky/$id/tisk',
  component: () => (
    <Suspense fallback={null}>
      <LeasingNabidkaTisk />
    </Suspense>
  ),
});
